import {environment} from '../environment/environment';
import {markers} from '../enumerator/mybus-events.enum';
import * as moment from 'moment';
import * as Paho from 'paho-mqtt';
import MapService from '../../services/map';
import ToasterService from './toaster';
import ToastSchema from '../schema/toaster.schema';
import Translate from '../../services/translate';

/**
 * --------------
 * MQTTService
 * --------------
 * gère la connexion au service MQTT
 */
export default class MQTTService {
    /** contient l'object paho.Client */
    static client = null;

    /** contient le dernier évenement reçu */
    static message;

    /** contient le dernier évenement reçu affiché */
    static oldMessage;

    /** nombre d'évenements */
    static nbTargetedEvent = 0;

    /** permet d'initialiser une seule fois la fonction messengerAnimation */
    static isLaunch = false;

    /** nombres de minutes pendant lesquels un event est valide */
    static validity = 15;

    /** temps en secondes pendant lequel un événement reste affiché (doit être inf à displayLoop) */
    static displayTime = 10;

    /** temps total entre deux affichages d'events */
    static displayLoop = 15;

    /**
     * -----------
     * initMQTT
     * -----------
     * connexion au channel dev/events mqtt
     * */
    static initMQTT = function () {
        MQTTService.connect()
            .then(function (message) {
                const topic = environment.env_topic + '/events';
                MQTTService.subscribe(topic, 1)
                    .then(function (result) {

                    });
            });
    }

    /**
     * ------------------
     * connect
     * ------------------
     * connexion au service broker
     */
    static connect = function () {
        return new Promise((successCallback, failureCallback) => {
            MQTTService.client = new Paho.Client(
                environment.mqtt_url,
                environment.mqtt_port,
                "/ws",
                environment.mqtt_client_prefix + parseInt(Math.random() * 100000000, 10)
            );

            let password = environment.env_topic + '|';

            MQTTService.fetchToken().then(function (token) {
                password += token.access_token;
                const options = {
                    timeout: 3,
                    useSSL: true,
                    keepAliveInterval: 30,
                    userName: "mybus.io" + Math.random() * 100000000, // nécessaire mais inutile ici
                    password: password,
                    onSuccess: function (message) {
                        MQTTService.handleConnectionSuccess(successCallback, message);
                    },
                    onFailure: function (message) {
                        MQTTService.handleConnectionFailed(failureCallback, message);
                    }
                };
                MQTTService.client.onConnectionLost = MQTTService.handleConnectionLost;
                MQTTService.client.onMessageArrived = MQTTService.handleMessageReceived;
                MQTTService.client.connect(options);
            });
        });
    }

    /**
     * ------------------
     * subscribe
     * ------------------
     * Subscribe to a given topic on the broker
     */
    static subscribe = function (topic, qos) {
        return new Promise((successCallback, failureCallback) => {

            MQTTService.client.subscribe(topic, {
                qos: qos,
                onSuccess: function () {
                    successCallback();
                },
                onFailure: function (err) {
                    const content = {
                        title: 'MQTT',
                        text: "Impossible de se souscrire au service d'évenements", // TODO: trad
                        status: 'warning'
                    }
                    //ToasterService.showToaster(new ToastSchema(content));
                    failureCallback(err);
                }
            });

        });
    };

    /**
     * ------------------
     * fetchToken
     * ------------------
     * récupère le token de l'api
     */
    static fetchToken = function () {
        return new Promise((successCallback, failureCallback) => {
            $.get(environment.url_api + '/oauth/v2/token', {
                client_id: environment.token_client_id,
                client_secret: environment.token_client_secret,
                grant_type: 'client_credentials'
            }).then(function (token) {
                successCallback(token);
            }).catch(function (err) {
                const content = {
                    title: 'MQTT',
                    text: Translate.print('fr.test'), // TODO: trad
                    status: 'warning'
                }
                //ToasterService.showToaster(new ToastSchema(content));
                failureCallback(err);
            });
        });
    }

    /**
     * ------------------
     * handleConnectionLost
     * ------------------
     * Handle mqtt connection interruption
     */
    static handleConnectionLost = function (message) {
        MQTTService.client = null;
    };

    /**
     * --------------------
     * handleMessageRecieved
     * --------------------
     * Handle message received message from the broker
     */
    static handleMessageReceived = function (message) {
        MQTTService.message = JSON.parse(message.payloadString);
        if (!MQTTService.isLaunch) {
            MQTTService.messengerAnimation();
            MQTTService.isLaunch = true;
        }
        $(document).trigger("handleMessageRecieved", MQTTService.message);
        if (MQTTService.nbTargetedEvent > 0 && MapService.map) {
            MapService.moveToTopLayer("targetEvent" + MQTTService.nbTargetedEvent);
        }

    };

    /**
     * --------------------
     * handleConnectionFailed
     * --------------------
     * Handle failed connection to the broker
     */
    static handleConnectionFailed = function (promise, message) {
        const content = {
            title: 'MQTT',
            text: "Impossible de se connecter au service d'évenements", // TODO: trad
            status: 'warning'
        }
        //ToasterService.showToaster(new ToastSchema(content));
        MQTTService.client = null;
        promise();
    };

    /**
     * -------------------
     * handleConnectionSuccess
     * -------------------
     * Handle successfull connection to the mqtt
     */
    static handleConnectionSuccess = function (promise, message) {
        MQTTService.generalAttemptConnect = 0;
        promise();
    };

    /**
     * ------------------
     * bubusMessengerAnimation
     * ------------------
     * gère l'affichage des événements sur la map
     */
    static messengerAnimation = function () {
        let timer = 0;
        let secondes = 5; // temps avant l'affichage du premier event
        let id; // identifiant du marker
        let event;

        setInterval(function () {
            if (timer >= secondes) {
                timer = 0;
                secondes = MQTTService.displayLoop;

                if (MQTTService.message !== MQTTService.oldMessage) {
                    event = MQTTService.buildMessage(MQTTService.message);
                    if (event) {
                        MQTTService.drawMessage(event);
                        id = "targetEvent" + MQTTService.nbTargetedEvent;
                    }
                }
            }

            if (timer === MQTTService.displayTime) {
                if (id !== undefined) {
                    MQTTService.eraseMessage(id);
                }
            }
            timer++;
        }, 1000);
    }

    /**
     * ---------------
     * printMessage
     * ---------------
     * affiche un événement sur la map
     * */
    static drawMessage = function (event) {
        $('[data-notification-content]').addClass('active');
        $('[data-notification-image]').attr('data-notification-image', event.marker.NAME);
        $('[data-notification-text]').text(event.text);

        // affichage du marker
        MQTTService.nbTargetedEvent++;
        const coord = [event.coord[1], event.coord[0]];
        if (MapService.map) {
            MapService.moveToTopLayer(markers.USERPOSITION.NAME)
            MapService.addPopupOnMap(coord, `<i class="fi fi-${event.marker.ICON}" class="event-map__icon"></i>`, {
                hasTimeout: true,
                className: 'main-event event-map'
            });
        }
        MQTTService.oldMessage = MQTTService.message;
    }

    /**
     * ---------------
     * unprintMessage
     * ---------------
     * cache un événement sur la map
     * */
    static eraseMessage = function () {
        $('[data-notification-content]').removeClass('active');
    }

    /**
     * ---------------
     * buildMessage
     * ---------------
     * crée la chaine de caractère de l'évenement
     * */
    static buildMessage = function (e) {
        const now = moment();
        const date = moment(e.timestamp * 1000, "x");

        // ne pas afficher les évenements qui datent de plus de 15mn
        if (Math.abs(now.diff(date, 'minutes')) < 15) {
            const dateNow = now.format("HH[h]mm");

            let name = '';
            (e.first_name !== undefined) ?
                name = e.first_name.substr(0, 1).toUpperCase() + e.first_name.substr(1, 2).toLowerCase() + '...' :
                name = Translate.print('mqtt.event.user');

            const agglo = e.name_agglo;
            const event = {
                text: agglo + ' / ' + dateNow + ' : ' + name + ' ',
                coord: e.coordinates_agglo.split(','),
                marker: '',
            }

            switch (e.action) {
                case 'VALIDATION':
                    event.text += Translate.print('mqtt.event.validation');
                    event.marker = markers.VALIDATION;
                    break;
                case 'ORDER':
                    event.text += Translate.print('mqtt.event.order');
                    event.marker = markers.ORDER;
                    break;
                case 'REGISTRATION':
                    event.text += Translate.print('mqtt.event.registration');
                    event.marker = markers.REGISTRATION;
                    break;
                case 'SMS_TICKET':
                    event.text += Translate.print('mqtt.event.smsticket');
                    event.marker = markers.SMSTICKET;
                    break;
                case 'ITINERARY':
                    event.text += Translate.print('mqtt.event.itinerary');
                    event.marker = markers.ITINERARY;
                    break;
                case 'TRANSFER':
                    event.text += Translate.print('mqtt.event.transfer');
                    event.marker = markers.TRANSFER;
                    break;
                default:
                    console.error(Translate.print('mqtt.noEvent'));
                    break;
            }
            return event;
        } else {
            return false;
        }
    }
}
